import React from "react"
import { FormattedMessage } from "react-intl"
import PriceList, { LimitRuleDto } from "../../state/price-list/PriceList"
import PricingRow from "../../state/pricing/PricingRow"

type OwnProps = {
    priceList: PriceList
}
const PriceListLimitRuleDisplayComponent = (props: OwnProps) => {
    const { priceList } = props

    const config = priceList.getValidationConfig() as LimitRuleDto
    const limitRows = getLimitRows(priceList, config.rowLimits)
    return ( 
        <>
            <ul>
                {limitRows.map(createRowInfo(config))}
            </ul>
            <span>
                <FormattedMessage 
                    id="price_list.edit.limit_rule.max_capacity"
                    defaultMessage="Max Capacity: {amount}"
                    values={{ amount: config.maxCapacity == 0 ? "None" : config.maxCapacity }}
                />
                &nbsp;
                {formatSoldAmount(config.usedCapacity)}
            </span>
        </>
    )
}

const getLimitRows = (priceList: PriceList, rowLimits) => {
    return priceList.getRows().filter(r => rowLimits[r.getId()])
}

const createRowInfo = (limitConfig) => (row: PricingRow) => {
    const {rowCounts, rowLimits} = limitConfig
    return (
        <li key={"limit-display-row-" + row.getId()} style={{listStyleType: "none"}}>
            {row.getTitle()}
            &nbsp;
            {rowLimits[row.getId()]}
            &nbsp;
            <small>
                {formatSoldAmount(rowCounts[row.getId()])}
            </small>
        </li>
    )
}

const formatSoldAmount = (amount: number) => (
    <small>
        (
        <FormattedMessage 
            id="price_list.edit.limit_rule.amount_sold"
            defaultMessage="{amount} sold"
            values={{
                amount: amount || 0
            }}
        />
        )
    </small>
)

export default PriceListLimitRuleDisplayComponent


// WEBPACK FOOTER //
// ./src/price-list/components/PriceListLimitRuleDisplayComponent.tsx